<template>
    <div>
        <div class="subtype-template">
            <div class="subtype-column">
                <template>
                    <b-form-checkbox
                       v-for="option in subtypes.slice(0, Math.ceil(subtypes.length/2))"
                       v-model="option.value"
                    >
                        {{ option.name }}
                    </b-form-checkbox>
                </template>
            </div>
            <div class="subtype-column">
                <template>
                    <b-form-checkbox
                       v-for="option in subtypes.slice(Math.ceil(subtypes.length/2), subtypes.length)"
                       v-model="option.value"
                    >
                        {{ option.name }}
                    </b-form-checkbox>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Subtypes',
  props: [
    'subtypes'
  ]
}
</script>

<style scoped>

</style>
